window.AwardCardContainer = phrase => {
	return {
		val: phrase,
	};
};
